import React from 'react';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { storeContext } from '../provider/Provider';
import PrimaryButton from '../../customUI/PrimaryButton';
import { websiteSwitchActions } from '../../store/website-switch-reducer';

const useStyles = makeStyles(() => ({
  websites__grid__container: {
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    padding: '1.3rem 1.5rem',
  },
  website__flex__item: {
    background: 'white',
    padding: '15px',
    margin: '0 10px 20px 10px',
    borderRadius: '16px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  },
  loginSubmitButton: {
    marginTop: 15,
    margin: 'auto',
    width: '80%',
  },
  item__content: {
    textAlign: 'center',
    fontSize: '1.2rem',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
    '& > span': {
      fontSize: '1.2rem',
    },
  },
}));

const WebsiteSwitch = () => {
  const [, setCookie] = useCookies(['websiteSwitch']);
  const { state, dispatch } = React.useContext(storeContext);
  const history = useHistory();
  const classes = useStyles();

  const loadPath = () => {
    if (state.auth.user.role === 'content_only') {
      return '/content';
    }
    if (state.websiteSwitch.landedOnLocation) {
      return state.websiteSwitch.landedOnLocation;
    }
    return '/';
  };

  const handleAccessWebsiteClick = (website, budget) => {
    dispatch({
      type: websiteSwitchActions.SET_CURRENT_WEBSITE,
      payload: { currentWebsite: website },
    });
    const date = new Date();
    const monthlyExpirationDate = new Date(date.setMonth(date.getMonth() + 1));
    setCookie('website', website, {
      path: '/',
      expires: monthlyExpirationDate,
    });
    setCookie('budget', budget, {
      path: '/',
      expires: monthlyExpirationDate,
    });
    history.push(loadPath());
  };

  if (state.websiteSwitch.websiteHasBeenChosen || state.websiteSwitch.allWebsites.length === 0) {
    history.push(loadPath());
  }

  return (
    <>
      <div className={classes.websites__grid__container}>
        {state.websiteSwitch.allWebsites.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        }).map((value) => (
          <div className={classes.website__flex__item} key={value.name}>
            <div className={classes.item__content}>
              <img
                src={`https://www.google.com/s2/favicons?domain=${value.name}`}
                alt="site icon"
                style={{ marginRight: 10 }}
              />
              {value.name}
            </div>
            <div className={classes.buttonWrapper}>
              <PrimaryButton
                variant="contained"
                color="primary"
                className={classes.loginSubmitButton}
                onClick={() => handleAccessWebsiteClick(value.name, value.budget)}
                aria-label="choose website"
              >
                Access
              </PrimaryButton>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default WebsiteSwitch;
